import { ThemeColors } from 'src/shared/styles/variables';
import styled from 'styled-components';

export const ProfileAccountSelectorContainer = styled('div')`
  .profile-section {
    display: flex;
    align-items: flex-start;
    .detail {
      flex: 1;
      .name {
        font-weight: bold;
        text-transform: capitalize;
      }
      .email {
        color: ${ThemeColors.monochromeDark};
      }
    }
    margin-bottom: 16px;
  }

  .accounts-section {
    .ln-c-accordion__head {
      .ln-c-accordion__title {
        font-family: 'Arial';
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        padding-left: 0;
      }
    }

    .is-open > .ln-c-accordion__body {
      padding: 0;
    }
  }
`;
